import './LiquidGlassCancelButton.css'

function LiquidGlassCancelButton({ onClick, children }) {
  return (
    <button className="btn-cancel-liquid" onClick={onClick}>
      {children || 'Annuler'}
    </button>
  )
}

export default LiquidGlassCancelButton

